import React from 'react'

export default function ModalComponent(props) {
    return (
        <div>
            <div id="myModal" class="modal">

                {props.children}

            </div>
        </div>
    )
}
